import React from 'react';
import { companyInfo } from '../mock';
import { Target, TrendingUp, Zap } from 'lucide-react';

const AboutSection = () => {
  const features = [
    {
      icon: Zap,
      title: 'AI Website Building',
      description: 'Professional landing pages and fullstack apps built with Emergent AI—fast, affordable, and stunning'
    },
    {
      icon: Target,
      title: 'Flowmingo AI Recruiter Service',
      description: 'Free AI-powered async interview platform for modern recruiting teams'
    },
    {
      icon: TrendingUp,
      title: 'Language Services',
      description: 'Translation, transcription, proofreading, editing, and voice over services'
    }
  ];

  return (
    <section 
      id="about"
      style={{
        background: '#000000',
        padding: '100px 7.6923%',
        position: 'relative'
      }}
    >
      <div 
        style={{
          maxWidth: '1400px',
          margin: '0 auto'
        }}
      >
        <div 
          style={{
            textAlign: 'center',
            marginBottom: '60px'
          }}
        >
          <h2 
            className="display-large"
            style={{
              marginBottom: '20px'
            }}
          >
            {companyInfo.aboutUs.title}
          </h2>
          <div 
            style={{
              width: '60px',
              height: '3px',
              background: '#00FFD1',
              margin: '0 auto'
            }}
          />
        </div>
        
        <div 
          style={{
            maxWidth: '900px',
            margin: '0 auto 80px',
            textAlign: 'center'
          }}
        >
          <p 
            className="body-large"
            style={{
              lineHeight: '1.8',
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}
          >
            Our consultancy brings together deep expertise in business development, international markets, and cultural competence to help SMEs and startups thrive globally.
          </p>
        </div>
        
        <div 
          className="dark-grid"
          style={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px'
          }}
        >
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                style={{
                  background: '#121212',
                  border: '1px solid rgba(255, 255, 255, 0.25)',
                  padding: '40px',
                  transition: 'all 0.4s ease-in-out',
                  borderRadius: '0px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.borderColor = '#00FFD1';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 255, 209, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div 
                  style={{
                    width: '56px',
                    height: '56px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '24px',
                    borderRadius: '0px'
                  }}
                >
                  <Icon size={28} color="#00FFD1" />
                </div>
                
                <h3 
                  className="heading-2"
                  style={{
                    marginBottom: '12px'
                  }}
                >
                  {feature.title}
                </h3>
                
                <p 
                  className="body-medium"
                  style={{
                    margin: 0,
                    color: 'rgba(255, 255, 255, 0.85)'
                  }}
                >
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
